import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import { CHAVES_LOGS } from './ProgressLogService';
import { CHAVES_PROGRESSO } from './ProgressService';
import { CHAVES_REACOES } from './StepReactionService';
import { Routine, ProgressLog } from '../types/entities';
import { ExecuteRoutineRequest, RoutineAdviceDTO, StepRemovalRequest } from '../types/dtos';

interface RoutinePayload {
  period: string;
  steps: Array<{
    stepOrder: number;
    productCategoryId: string;
    instructions: string;
    timerDurationSeconds?: number | null;
  }>;
}

export const CHAVES_ROTINAS = {
  dominio: ['rotinas'] as const,
  lista: (userId: string) => ['rotinas', 'lista', userId] as const,
};

const RoutineService = {
  // POST /api/v1/users/{userId}/routines  (upsert por período)
  createRoutine: (userId: string, routineData: RoutinePayload): Promise<AxiosResponse<Routine>> =>
    api.post(`/users/${userId}/routines`, routineData).then(invalidando(CHAVES_ROTINAS.dominio)),

  // PUT /api/v1/users/{userId}/routines/{routineId}
  updateRoutine: (userId: string, routineId: string, routineData: RoutinePayload): Promise<AxiosResponse<Routine>> =>
    api.put(`/users/${userId}/routines/${routineId}`, routineData).then(invalidando(CHAVES_ROTINAS.dominio)),

  // GET /api/v1/users/{userId}/routines
  getRoutines: (userId: string): Promise<AxiosResponse<Routine[]>> =>
    api.get(`/users/${userId}/routines`),

  // POST /api/v1/users/{userId}/routines/ai-adjust-after-removal
  // O usuário tirou uma etapa e disse por quê: a IA reavalia o período aberto no editor.
  // Só sugere — nada é salvo, por isso não invalida nada. Quem salva continua sendo o
  // createRoutine/updateRoutine, quando o usuário confirmar a rotina na tela.
  adjustAfterStepRemoval: (userId: string, payload: StepRemovalRequest): Promise<AxiosResponse<RoutineAdviceDTO>> =>
    api.post(`/users/${userId}/routines/ai-adjust-after-removal`, payload),

  // POST /api/v1/users/{userId}/routines/{routineId}/execute
  // Executar gera um ProgressLog com as reações das etapas: derruba logs,
  // progresso e estatísticas de reação de uma vez.
  executeRoutine: (userId: string, routineId: string, executionData: ExecuteRoutineRequest): Promise<AxiosResponse<ProgressLog>> =>
    api
      .post(`/users/${userId}/routines/${routineId}/execute`, executionData)
      .then(invalidando(CHAVES_LOGS.dominio, CHAVES_PROGRESSO.dominio, CHAVES_REACOES.dominio)),
};

export default RoutineService;
